import { createReduxAction, ReduxAction } from '../../utils';
import { modalWindowConstants } from './actionTypes';

export const openModal = (): ReduxAction<
    typeof modalWindowConstants.OPEN_MODAL_WINDOW
> => createReduxAction(modalWindowConstants.OPEN_MODAL_WINDOW);

export const closeModal = (): ReduxAction<
    typeof modalWindowConstants.CLOSE_MODAL_WINDOW
> => createReduxAction(modalWindowConstants.CLOSE_MODAL_WINDOW);

export const setFileMimetype = (
    fileMimetype: string,
): ReduxAction<
    typeof modalWindowConstants.SET_FILE_MIMETYPE,
    { fileMimetype: string }
> =>
    createReduxAction(modalWindowConstants.SET_FILE_MIMETYPE, { fileMimetype });

export const setFileId = (
    fileId: number,
): ReduxAction<typeof modalWindowConstants.SET_FILE_ID, { fileId: number }> =>
    createReduxAction(modalWindowConstants.SET_FILE_ID, { fileId });

export const setFileUrl = (
    fileUrl: string,
): ReduxAction<typeof modalWindowConstants.SET_FILE_URL, { fileUrl: string }> =>
    createReduxAction(modalWindowConstants.SET_FILE_URL, { fileUrl });

export const setFileBlob = (
    fileBlob: Blob,
): ReduxAction<typeof modalWindowConstants.SET_FILE_BLOB, { fileBlob: Blob }> =>
    createReduxAction(modalWindowConstants.SET_FILE_BLOB, { fileBlob });
